import { render, staticRenderFns } from "./VariantQuantities.vue?vue&type=template&id=5043d7f2&scoped=true&"
import script from "./VariantQuantities.vue?vue&type=script&lang=js&"
export * from "./VariantQuantities.vue?vue&type=script&lang=js&"
import style0 from "./VariantQuantities.vue?vue&type=style&index=0&id=5043d7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5043d7f2",
  null
  
)

export default component.exports